<template>
    <div class="admin-instance-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content admin-instance-page__intro">
                    <router-link
                        to="/plan"
                        class="admin-instance-page__back admin-instance-page__back--pill"
                        :title="trans('plan.plan')"
                        :aria-label="trans('plan.plan')"
                    >
                        <admin-icon name="chevron-left" aria-hidden="true"></admin-icon>
                    </router-link>
                    <div class="admin-instance-page__intro-text">
                        <div class="admin-instance-list__title-row">
                            <h3 class="nk-block-title page-title mb-0">{{trans('plan.edit_plan')}}</h3>
                        </div>
                        <div class="nk-block-des text-soft">
                            <p>{{ trans('plan.module_info_description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card admin-plan-form-card">
            <div class="card-body admin-plan-form-card__body">
                <plan-form :id="id"></plan-form>
            </div>
        </div>
    </div>
</template>

<script>
    import planForm from './form';

    export default {
        components : { planForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('edit-plan')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
        }
    }
</script>
